import { FC, CSSProperties, ReactNode } from 'react';
import styles from './BoxContainer.module.scss';

interface IBoxContainer {
  children: ReactNode;
  height?: number | string;
  width?: number;
  style?: CSSProperties;
}

const BoxContainer: FC<IBoxContainer> = ({
  children,
  height,
  width,
  style,
}) => {
  const heightBox = height ?? 282;
  const widthBox = width ?? 244;

  return (
    <div className={styles['BoxContainerWrapper']}>
      <section
        className={styles['BoxContainer']}
        style={{ ...style, height: heightBox, width: widthBox }}
      >
        {children}
      </section>
    </div>
  );
};

export default BoxContainer;
